<template>
    <div class="accordion__body">
        <div class="item">
            <button
                v-if="!mq"
                class="item__title"
                @click="toggle"
                :class="{ 'is-active': isActive }">
                <slot name="title"></slot>
                <span class="icon"></span>
            </button>
            <span v-else class="item__title" style="cursor: normal">
                <slot name="title"></slot>
            </span>
            <Transition name="accordion" @enter="enter" @after-enter="afterEnter" @leave="leave">
                <div class="item__body" v-if="isActive">
                    <slot name="body"></slot>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';

import { useMediaQuery } from '../../composables/useMediaQuery';

const mq = useMediaQuery('(min-width: 1024px)');

const isActive: Ref<boolean> = ref(mq.value ?? false);

const toggle = () => {
    isActive.value = !isActive.value;
};

const enter = (el: HTMLElement) => {
    el.style.height = 'auto';

    const height = getComputedStyle(el).height;
    el.style.height = '0';

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = height;
    });
};

const afterEnter = (el: HTMLElement) => {
    el.style.height = 'auto';
};

const leave = (el: HTMLElement) => {
    el.style.height = getComputedStyle(el).height;

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = '0';
    });
};
</script>
